import { useEffect } from 'react'
import { X } from 'lucide-react'
import { trackEvent } from '../../lib/analytics'

interface Props {
  isOpen: boolean
  onClose: () => void
  actionName: string
  onSignUp: () => void
}

export default function SignupGateModal({ isOpen, onClose, actionName, onSignUp }: Props) {
  // Records what a signed-out visitor was trying to do when the gate stopped them.
  // Every tab shares this component, so tracking here covers all of them at once.
  // Must sit above the early return below — hooks cannot run conditionally.
  useEffect(() => {
    if (isOpen && actionName) trackEvent('signup_gate_shown', { action: actionName })
  }, [isOpen, actionName])

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-[150] flex items-end justify-center"
      style={{ background: 'rgba(8,4,1,0.75)' }}
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm bg-white rounded-t-3xl px-5 pt-5 pb-8 animate-slide-up"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-4">
          <div>
            <p className="font-bold text-coffee-800 text-base">Sign up to {actionName}</p>
            <p className="text-coffee-400 text-xs mt-0.5">Create a free account to unlock all features.</p>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            className="w-7 h-7 rounded-full bg-cream-100 flex items-center justify-center flex-shrink-0 ml-3"
          >
            <X size={13} className="text-coffee-400" />
          </button>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onSignUp}
            className="flex-1 py-3 rounded-xl text-white text-sm font-semibold transition-all"
            style={{ background: 'linear-gradient(135deg, #c8853a, #9b5e1a)' }}
          >
            Sign up ☕
          </button>
          <button
            onClick={onClose}
            className="px-5 py-3 rounded-xl bg-cream-100 text-coffee-500 text-sm font-medium"
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  )
}
